import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Link, useHistory } from 'react-router-dom';
import { Icon, Loader, Modal } from 'semantic-ui-react';
import Rpad from './Rpad';
import AddSearchModal from './AddSearchModal';
import { useAddProperty } from './AddPropertyContext';
import { Order } from '../../types';
import axios from 'axios';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const Close = styled.button`
  display: flex;
  justify-content: flex-end;
  padding: 15px;
  background-color: #fff;
  border: none;
  cursor: pointer;
`;
const ActualContent = styled.div`
  padding: 0 35px;
`;
const Header = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #4d4e4d;
  border-bottom: 1px solid #e5e5ea;
  padding: 0px 35px 16px 35px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 9px;
  justify-content: flex-end;
  border-top: 1px solid #e5e5ea;
  padding-top: 24px;
  padding-bottom: 24px;
`;

const CancelButton = styled.button`
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  color: #444444;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  width: 127px;
  height: 47px;
  cursor: pointer;
`;
const Children = styled.div`
  margin-top: 24px;
`;
const ConfirmButton = styled.button`
  background: #444;
  border: 1px solid #444;
  border-radius: 5px;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  width: 127px;
  height: 47px;
  cursor: pointer;
  margin-right: 35px;
`;
interface Props {
  open: boolean;
  onClose: any;
  order: Order;
  getOrderDetails:() => any;
}

const AddPropertyModal = (props: Props) => {
  const { validateProperty, onSubmit, onCancel, submitting } = useAddProperty();
  const [openSearchModal, setOpenSearchModal] = useState(false);

  const nextProperty = () => {
    const err = validateProperty();
    if (!err) {
      setOpenSearchModal(true);
    } 
  };
  return (
    <Modal open={props.open} style={{ width: 760, zIndex: 500 }} onClose={props.onClose}>
      {openSearchModal ? (
        <AddSearchModal
          open={openSearchModal}
          onClose={() => {
            setOpenSearchModal(false);
            props.onClose();
          }}
          order={props.order}
          onCloseSearch={() => setOpenSearchModal(false)}
          getOrderDetails={props.getOrderDetails}
        />
      ) : (
        <ModalContent>
          <Close onClick={() => {
              props.onClose();
              onCancel();
              }}>
            <Icon name="close" />
          </Close>
          <Header>Add Property</Header>
          <ActualContent>
            <Rpad />
          </ActualContent>
          <ButtonContainer>
            <CancelButton onClick={() => {
              props.onClose();
              onCancel();
              }}>Cancel</CancelButton>
            <ConfirmButton onClick={nextProperty}>
              {submitting ? <Loader style={{ margin: '0 auto' }} size="mini" inline="centered" /> : 'Next'}
            </ConfirmButton>
          </ButtonContainer>
        </ModalContent>
      )}
    </Modal>
  );
};

export default AddPropertyModal;
